import React from "react";
import Container from "./containerUserFeedBack";
import { checkIcon } from "../Images"
import './feedback.css'
class UserContainer extends React.Component {
    render() {
        const { isMobile,logo ,subsidiaryName } = this.props;
        return (
            <Container isMobile={isMobile} logo={logo}>
                <div className={isMobile ? "containerSM" : "containerMD"}>
                    <img src={checkIcon} className={isMobile ? "doneIconSM" : "doneIconMD"}></img>
                    <h4 className={isMobile ? "alreadyExistHeaderSM" : "alreadyExistHeaderMD"}>
                        Your feedback has already recorded
                    </h4>

                    <a href="https://www.daffodilsw.com/" style={{ textDecoration: "none" }}>
                        <a href="https://www.daffodilsw.com/" style={{ textDecoration: "none" }}>
                            {subsidiaryName === "Unthinkable Solutions LLP" || subsidiaryName === "Hisar-Unthinkable Solutions LLP" ?
                                <div className="submitButton unthinkable">
                                    <div className="submitText">Done</div>
                                </div> :
                                <div className="submitButton daffodil">
                                    <div className="submitText">Done</div>
                                </div>}
                        </a>
                    </a>
                </div>
            </Container>
        );
    }
}

export default UserContainer;
